import { Tooltip, Title, Text } from "@mantine/core";
import "./styles.scss";

interface Props {
  label: JSX.Element,
  children: string
}

function Tooltips({ label, children }: Props) {
  return (
    <Tooltip
      label={
        <Text className="label" size="xs">{label}</Text>
      }
      children={
        <Title className="title" order={5}>{children}</Title>
      }
      color="indigo"
      transition="skew-down"
      transitionDuration={300}
      transitionTimingFunction="ease"
      withArrow
      arrowSize={3}
    />
  )
}

export default Tooltips
